import { FaBars } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";
import { Button, Dropdown } from "antd";
import media from "../../../media";
import { logoutAdmin } from "../../../store/thunks/authThunk";
import { User } from "lucide-react";
export default function Header2({ toggleSidebar }) {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth || {});

  const handleLogout = () => {
    dispatch({ type: "RESET_STORE" });
    dispatch(logoutAdmin());
  };

  const menu = [
    {
      label: (
        <span
          className="menu-link cursor-pointer"
          onClick={() => {
            handleLogout();
          }}
        >
          <span className="menu-text">Logout</span>
        </span>
      ),
      key: "3",
    },
  ];

  return (
    <header className="top-header">
      <button className="toggle-btn" onClick={toggleSidebar}>
        <FaBars color="#1F2937" />
      </button>

      <div className="header-right">
        <div className="user">
          <Dropdown
            menu={{ items: menu }}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: "10px",
              }}
              className="user-image"
            >
              <img src={media.dummy} alt="User" className="user-image border" />

              <h5 className="text-dark mb-0 font-size-sm">{auth?.name}</h5>
            </div>
          </Dropdown>
          {/* 
          <Dropdown
            menu={{ items: menu }}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: "10px",
              }}
              className="user-image"
            >
              <h5 className="text-white mb-0 font-size-sm">{auth?.name}</h5>
            </div>
          </Dropdown> */}
        </div>
      </div>
    </header>
  );
}
